export const ButtonConfig = {
    SAVE: {
      className: 'p-button-rounded',
      icon: 'pi pi-save',
      label: 'Save',
      iconPos: 'left',
    }
  };
  